import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "WifiService",
  controller: "Wifi",
};

const methods = [
  "GetDeviceListPaging"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const WifiApi = ZJApi.defineNewApi("WifiApi", factory);

export default WifiApi;
